import React from "react";
import { LabelField } from ".";
export const MyCheckbox = ({
  title,
  checked,
  name,
  handlechange,
  style,
  titleStyles,
  ...props
}) => {
  return (
    <div className="d-flex" style={{ alignItems: "baseline", backgroundColor: 'transparent !importent', opacity: props?.disabled ? 0.5 : 1, ...style }}>
      <label className="checkbox checkbox-lg checkbox-single mr-4"
        style={{ cursor: props?.disabled ? 'not-allowed' : 'pointer' }}
      >
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={handlechange}
          {...props}
        />
        <span />
      </label>
      <span>
        <LabelField title={title}
          style={{ ...(titleStyles || {}), cursor: props?.disabled ? 'not-allowed' : undefined }}
        />
      </span>
    </div>
  );
};
